export function obterTetoDescontoCupom(cupom = {}) {
  if (cupom.tipoDesconto !== "%") {
    return null;
  }
  const teto = Number(cupom.valorTeto);
  if (!Number.isFinite(teto) || teto <= 0) {
    return null;
  }
  return teto;
}

export function limitarDescontoAoTeto(descontoCalculado, tetoDesconto) {
  const desconto = Number(descontoCalculado) || 0;
  if (!tetoDesconto || desconto <= tetoDesconto) {
    return desconto;
  }
  return Number(tetoDesconto.toFixed(2));
}

function chaveLinhaProduto(item) {
  return item.idcadastroextraproduto || item.idcadastroextra;
}

function totalValorLinhas(itens) {
  return itens.reduce((soma, item) => {
    const preco = Number(item.preco) || 0;
    const quantidade = Number(item.quantidade) || 0;
    return soma + preco * quantidade;
  }, 0);
}

function ratearDescontoFixoNasLinhas(itensAfetados, valorDescontoTotal) {
  const totalValor = totalValorLinhas(itensAfetados);
  const valorAlvoCentavos = Math.round(Number(valorDescontoTotal) * 100);
  const descontosPorChave = new Map();

  if (!totalValor || !valorAlvoCentavos || !itensAfetados.length) {
    return descontosPorChave;
  }

  const linhas = itensAfetados.map(item => {
    const preco = Number(item.preco) || 0;
    const quantidade = Number(item.quantidade) || 0;
    const valorLinha = preco * quantidade;
    return {
      chave: chaveLinhaProduto(item),
      valorLinha,
      centavosBase: Math.floor((valorAlvoCentavos * valorLinha) / totalValor)
    };
  });

  let distribuido = linhas.reduce((soma, linha) => soma + linha.centavosBase, 0);
  let resto = valorAlvoCentavos - distribuido;
  linhas.sort((a, b) => b.valorLinha - a.valorLinha);
  for (let indice = 0; indice < linhas.length && resto > 0; indice++) {
    linhas[indice].centavosBase += 1;
    resto -= 1;
  }

  linhas.forEach(linha => {
    descontosPorChave.set(linha.chave, linha.centavosBase / 100);
  });
  return descontosPorChave;
}

export function calcularDescontoPercentualComTetoNasLinhas(
  itensAfetados,
  percentualDesconto,
  tetoDesconto
) {
  const percentual = Number(percentualDesconto) || 0;
  const descontosIniciais = itensAfetados.map(item => {
    const preco = Number(item.preco) || 0;
    const quantidade = Number(item.quantidade) || 0;
    const descontoLinha = Number(
      ((percentual / 100) * preco * quantidade).toFixed(2)
    );
    return {
      chave: chaveLinhaProduto(item),
      descontoLinha
    };
  });

  const somaPercentual = descontosIniciais.reduce(
    (soma, linha) => soma + linha.descontoLinha,
    0
  );

  if (!tetoDesconto || somaPercentual <= tetoDesconto) {
    const descontosPorChave = new Map();
    descontosIniciais.forEach(linha => {
      descontosPorChave.set(linha.chave, linha.descontoLinha);
    });
    return { descontosPorChave, totalDesconto: somaPercentual };
  }

  const descontosPorChave = ratearDescontoFixoNasLinhas(
    itensAfetados,
    tetoDesconto
  );
  const totalDesconto = [...descontosPorChave.values()].reduce(
    (soma, valor) => soma + valor,
    0
  );
  return { descontosPorChave, totalDesconto: Number(totalDesconto.toFixed(2)) };
}
